import axios from 'axios';

export const actions = {
    loadTour({commit}, id) {
        commit('setPending', true);
        axios.get(`/api/fetch-travel-data/tour/${id}`)
            .then(response => {
                return response.data[0];
            })
            .then(route => {
                commit('setRoute', route);
                if (route && route.visitorCountryCode) {
                    commit('setPhoneCountry', route.visitorCountryCode);
                }
            })
            .catch(err => {
                commit('setError', err);
            })
            .finally(() => {
                commit('setPending', false);
            });
    },

    loadCountry({commit}, id) {
        commit('setPending', true);
        axios.get(`/api/fetch-travel-data/country/${id}`)
            .then(response => {
                return response.data[0];
            })
            .then(country => {
                commit('setCountry', country);
                if (country && country.visitorCountryCode) {
                    commit('setPhoneCountry', country.visitorCountryCode);
                }
            })
            .catch(err => {
                commit('setError', err);
            })
            .finally(() => {
                commit('setPending', false);
            });
    },

    submitForm({commit}, form) {
        commit('setPending', true);
        form.budget = `${form.budget[0]}, ${form.budget[1]}`;

        const data = JSON.stringify(form);
        const config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: '/api/inquiry',
            headers: {
                'Content-Type': 'application/json',
            },
            data : data
        };

        return axios(config)
            .then(response => {
                return response.data[0]
            })
            .then(inquiry => {
                commit('setInquiry', inquiry);
                return inquiry; // Return the inquiry data
            })
            .catch(err => {
                commit('setError', err);
                throw err; // Re-throw the error
            })
            .finally(() => {
                commit('setPending', false);
            });
    },

    submitPhone({commit}, phoneForm) {
        commit('setPending', true);

        const data = JSON.stringify(phoneForm);
        const config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: '/api/inquiry/phone',
            headers: {
                'Content-Type': 'application/json',
            },
            data : data
        };

        return axios(config)
            .then(response => {
                return response.data;
            })
            .then(route => {
                route.messagesForTraveller.reverse();
                commit('setRoute', route);
            })
            .catch(err => {
                commit('setError', err);
            })
            .finally(() => {
                commit('setPending', false);
            });
    },

    updateMessage({commit}, {inquiryId, message}) {
        commit('setPending', true);

        const data = JSON.stringify({
            inquiry: inquiryId,
            message: message
        });
        const config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: '/api/inquiry/update-message',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            },
            data : data
        };

        return axios(config)
            .then(response => {
                // Check if response is JSON
                if (response.headers['content-type'] && response.headers['content-type'].includes('application/json')) {
                    return response.data;
                } else {
                    // Handle HTML response (likely an error page)
                    throw new Error('Server returned HTML instead of JSON. This might be an authentication or routing issue.');
                }
            })
            .then(result => {
                if (result && typeof result === 'object') {
                    // Handle array response format by extracting first element
                    const data = Array.isArray(result) ? result[0] : result;
                    
                    // Update the travelData.message in the store
                    commit('setMessage', message);
                    
                    return data;
                } else {
                    throw new Error('Invalid response format from server');
                }
            })
            .catch(err => {
                console.error('Update message error:', err);
                commit('setError', err);
                throw err;
            })
            .finally(() => {
                commit('setPending', false);
            });
    }
};